import { Injectable } from '@angular/core';
import { GenericResponse } from 'projects/Autofacets-Core/src/app/business-entities/generic-response.class';
import { DataService } from 'projects/Autofacets-Core/src/app/services/data.service';
import { CheckInUserDataService } from '../data-services/checkin-user-data.service';
import {
  CheckInDealerRequestModel,
  CheckInUserRequestModel,
  TraversalRequestModel,
} from '../business-entities/checkin-user-model';

@Injectable({
  providedIn: 'root',
})
export class CheckinUserService {
  selectedDealers: any;
  dealerList: any;
  selectedDate: any;
  checkinUserListRequest: CheckInUserRequestModel = {
    searchTerm: '',
    startRecordNumber: 0,
    pageSize: 25,
    sortColumn: '',
    sortDirection: '',
    selectedDealers:[],
    selectedDate: '',
    isExport : false,
  };
  checkinDealerListRequest: CheckInDealerRequestModel = {
    searchTerm: '',
    startRecordNumber: 0,
    pageSize: 25,
    sortColumn: '',
    sortDirection: '',
    dealerId:'',
    selectedDate: '',
    isExport : false,
    appointmentCheckInStatus:0
  };
  traversalListRequest: TraversalRequestModel = {
    searchTerm: '',
    startRecordNumber: 0,
    pageSize: 25,
    sortColumn: '',
    sortDirection: '',
    workOrderNo:'',
  };
  dealerId:string =''

  constructor(private dataProvider: DataService,
    private checkInUserDataService :CheckInUserDataService) {}

  async getCheckInUserList(requestModel: CheckInUserRequestModel): Promise<GenericResponse<any>> {
    return this.checkInUserDataService.getCheckInUserList(requestModel);
  }

  async getCheckInDealerList(requestModel: CheckInDealerRequestModel): Promise<GenericResponse<any>> {
    return this.checkInUserDataService.getCheckInDealerList(requestModel);
  }

  async GetCheckinTraversalList(requestModel: TraversalRequestModel): Promise<GenericResponse<any>> {
    return this.checkInUserDataService.GetCheckinTraversalList(requestModel);
  }
}
